// extracted by mini-css-extract-plugin
export default {"BrandsContainer":"Brands_BrandsContainer__GmrgJ","ImgContainer":"Brands_ImgContainer__qAepq","img":"Brands_img__5bzbS"};